import { useMutation, useQuery } from "@tanstack/react-query";
// * hooks
import axiosClient from "../services/axiosClient";
// * constants
import { apiUrls } from "../utils/urls";

const getRewardItemList = async (token: string) => {
  const { data } = await axiosClient.get(apiUrls.getRewardList, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

const getBrandList = async (token: string) => {
  const { data } = await axiosClient.get(apiUrls.brandList, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

/**
 * * get reward items list
 *
 * @param token string
 * @returns
 */
const useRewardItemsList = (token: string) => {
  return useQuery(
    ["rewardItem", { type: "list" }],
    () => getRewardItemList(token),
    {
      enabled: token !== "",
    }
  );
};

/**
 * * get reward items list
 *
 * @param token string
 * @returns
 */
const useBrandItemsList = (token: string) => {
  return useQuery(["brand", { type: "list" }], () => getBrandList(token), {
    enabled: token !== "",
  });
};

/**
 * * register a reward item
 *
 * @param token
 * @param callbackSuccess
 * @param callbackFailure
 */
const useRegisterRewardMutation = (
  token: string,
  callbackSuccess?: (_: any) => void,
  callbackFailure?: (error: any) => void
) => {
  return useMutation(
    (data: any) => {
      return axiosClient.post(apiUrls.createReward, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    {
      onSuccess: async (_) => {
        if (callbackSuccess) {
          callbackSuccess(_);
        }
      },
      onError: async (_) => {
        if (callbackFailure) {
          callbackFailure(_);
        }
      },
    }
  );
};

const useDeleteRewardMutation = (
  token: string,
  callbackSuccess?: () => void,
  callbackFailure?: () => void
) => {
  return useMutation(
    (id: string) => {
      return axiosClient.delete(apiUrls.rewardItem.replace(/%s/, id), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    {
      onSuccess: async () => {
        if (callbackSuccess) {
          callbackSuccess();
        }
      },
      onError: async () => {
        if (callbackFailure) {
          callbackFailure();
        }
      },
    }
  );
};

export {
  useRewardItemsList,
  useBrandItemsList,
  useRegisterRewardMutation,
  useDeleteRewardMutation,
};
